import React from 'react'
import './Allviewquerydetails.css'
import TitleNames from '../../Component/Header/TitleNames'
import { Link } from 'react-router-dom'
const Allviewquerydetails = () => {
  return (
    <>
      <div>
        <div>
          <TitleNames />
        </div>
        <div className='ViewQueryDetailsMain'>
          <div className='container-fluid'>
            <Link to="/allquerydashboard">  <button className="btn btn btn-primary btn-rounded ArrowClass"><i class="fa fa-arrow-left"></i> Back</button></Link>


            <div className='HeadingADetails'><p>Al Details</p></div>


            <div className='row SubContent'>
              <div className="col-lg-6">
                <div className="card ViewDetailsPrifileDetails">
                  <form action="">
                    <div class="form-row">
                      <div className="form-group col-lg-6 col-md-12 ">
                        <div className='QueryDetailsContent'><p className='UserNameQuery'>User NAME </p>
                          <span className='Dotspace'>:</span>
                          <p className='NameQuery'>Gokul</p></div>


                      </div>
                      <div class="form-group col-lg-6 col-md-12">
                        <div className='QueryDetailsContent'><p className='UserNameQuery'>User Numbe </p>
                          <span className='Dotspace'>:</span>
                          <p className='NameQuery'>6776776</p></div>



                      </div>
                    </div>
                    <div className="form-group">
                      <div className='QueryDetailsContent'>
                        <p className='UserNameQuery NameQuery'>Query Date & Time </p>
                        <span className='Dotspace'>:</span>
                        <p className='NameQuery'>DD/MM/YYYY  HH:MM
                        </p>
                      </div>

                    </div>
                    <div className="form-row">
                      <div className="form-group col-lg-6 col-md-6">
                        <div className='QueryDetailsContent'>
                          <p className='UserNameQuery'>Category 1 </p>
                          <span className='Dotspace'>:</span>
                          <p className='NameQuery'>value</p>
                        </div>

                      </div>
                      <div className="form-group col-lg-6 col-md-6">
                        <div className='QueryDetailsContent'>
                          <p className='UserNameQuery'>Category 1 </p>
                          <span className='Dotspace'>:</span>
                          <p className='NameQuery'>value</p>
                        </div>


                      </div>
                    </div>
                  </form>

                  <div className='ParaQuery'>
                    <p className='QueryLines'>Query:</p>
                    <p className='QesryParaLines'>   Lorem, ipsum dolor sit amet consectetur adipisicing elit. Animi iusto molestiae cum eos quas
                      omnis quia quis illo nobis. Ducimus cupiditate voluptas et sequi alias iure? Officia blanditiis magnam quisquam?</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card ViewDetailsPrifileDetails">
                  <div className='ConcernMainHeading'> <h5>Are you have a concern?</h5></div>
                 

                  <div>
                    <h5>Pain </h5>
                    <div className=" ConcerQuestion">
                      <p className='QuestionConcern'>How many days?</p>

                      <input type="text"  class="BoxQuestionDetails" id="inputZip"></input>
                    
                    </div>
                    <div className=" ConcerQuestion">
                    <p  className='QuestionConcern'>Intensity of pain</p>
                    <input type="text" class="BoxQuestionDetails" id="inputZip"></input>
                    </div>
                   

                  </div>
                  <div>
                    <h5>Heavy Flow
                    </h5>
                    <div className=" ConcerQuestion">
                    <p  className='QuestionConcern'>Intensity of pain</p>
                    <input type="text" class="BoxQuestionDetails" id="inputZip"></input>
                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>


        </div>
      </div>
    </>

  )
}

export default Allviewquerydetails